import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const difficultyLevelDetailsApi = createAsyncThunk(
    'auth/difficulty-level/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.difficultyLevelAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const difficultyLevelDetailsSlice = createSlice({
    name: 'difficulty-level details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetdifficultyLevel: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(difficultyLevelDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(difficultyLevelDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(difficultyLevelDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetdifficultyLevel } = difficultyLevelDetailsSlice.actions;
export const difficultyLevelDetailsReducer = difficultyLevelDetailsSlice.reducer